export default "__VITE_ASSET__D6rW2$tB__"